import { IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxUIModelT } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import { AnyServiceModel } from "./AnyServiceModel";

class SeacrhCriteriaItem {
    public Id: string;
    public EmployeeList: EmployeeUIModel[];
    public AllEmployees: boolean;

    public ServiceList: CheckboxUIModelT<ServiceOrComboTableItem<IComboOrServiceItem>>[];
    public IsFromService: boolean;

    public AnyServiceList: AnyServiceModel[];
}

export { SeacrhCriteriaItem };
